import { useAuthStore } from './stores';

export interface FetcherError extends Error {
    info?: unknown;
    status?: number;
}

export default async function CloakFetcher(route: string | string[], instanceHost?: string) {
    const cloak = useAuthStore.getState().keyCloak;
    await cloak?.updateToken(5);
    if (!cloak?.token) {
        throw new Error('Unauthorized');
    }

    const parsedRoute = Array.isArray(route) ? route[0] : route;

    const base = instanceHost ?? '';

    const res = await fetch(`${base}/api/${parsedRoute}`, {
        headers: new Headers({ Authorization: 'Bearer ' + cloak.token }),
    });

    if (!res.ok) {
        const error: FetcherError = new Error('An error occurred while fetching the data.');
        // Attach extra info to the error object.
        error.info = await res.json();
        error.status = res.status;
        throw error;
    }

    return res.json();
}
